export const SET_RECIPIENT_DETAILS = 'SET_RECIPIENT_DETAILS';

const initialState = {
  title: '',
  practice: '',
  street: '',
  city: '',
  state: '',
  postcode: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_RECIPIENT_DETAILS:
      const newState = state;
      newState[action.category] = action.data;
      return {
        ...newState,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/recipientDetails.js